<div class="layout-topbar" >
    <div class="layout-topbar-wrapper align-items-center">
        <div class="layout-topbar-logo-wrapper ml-4 flex align-items-center">
            <a routerLink="/configuracion/landing" class="cursor-pointer">
                <img src="assets/img/logo-tramitfly.png" alt="Logo tramitfly" width="100%" style="max-height:44px" >
            </a>
        </div>

        <div class="layout-topbar-right flex justify-content-center align-items-center">
            <div [ngClass]="{'mr-3':!isLoggedIn}">
                <a routerLink="/configuracion/landing" class="flex justify-content-center align-items-center">
                    <i class="pi pi-home" style="font-size: 1.7rem; color: #14356B;"></i>
                    <span  class="ml-2" style="color: #14356B;font-size: 1.2rem;">{{'app-topbar.inicio' | translate}} </span>
                </a>
            </div>

            <ul class="layout-topbar-actions  ml-5" >
                <li *ngIf="false">
                    <a  class="p-button-rounded cursor-pointer" >
                        <i class="pi pi-bell"></i>
                    </a>
                </li>
                <li #profile class="topbar-item profile-item"  *ngIf="isLoggedIn"
                    [ngClass]="{'active-topmenuitem': appMain.activeTopbarItem === profile}">
                    <a href="#" (click)="appMain.onTopbarItemClick($event,profile)" >
                            <span class="profile-image-wrapper fadeInDown">
                                <p-avatar [label]="shortName" size="large"  [style]="{'background-color': '#0A4360', 'color': '#ffffff'}"  shape="circle"></p-avatar>
                            </span>
                    </a>
                    <ul class="profile-item-submenu fadeInDown">
                        <li class="profile-submenu-header cursor-auto" style=" display: flex; justify-content: center;">
                            <div class="profile flex align-items-center">
                                <p-avatar [label]="shortName" [style]="{'background-color': '#0A4360', 'color': '#ffffff'}"  size="large" shape="circle"></p-avatar>
                                <h1>{{userName}}</h1>
                            </div>
                        </li>
                        <li>
                            <button pButton type="button" (click)="logout()">Cerrar sesión</button>
                        </li>
                    </ul>
                </li>
                <li>
                    <a href="#" class="sidebar-menu-button xl:hidden lg:hidden"
                       (click)="appMain.onMenuButtonClick($event)">
                        <i class="pi pi-bars" style="color:white;"></i>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>
